import _extends from "@babel/runtime/helpers/extends";
import getComponentFromLookup from "../../helpers/logic/get-component-from-lookup";
import { TRIGGER_TYPES } from "../constants";
var defaultLookup = "button";
var useTrigger = function useTrigger(triggerType, props, isDisabled) {
  return getComponentFromLookup(TRIGGER_TYPES, triggerType, defaultLookup, _extends({
    disabled: isDisabled
  }, props));
};
export default useTrigger;